import { render } from "./AboutUsHomePageSmallScreen.vue?vue&type=template&id=00750e29"
import script from "./AboutUsHomePageSmallScreen.vue?vue&type=script&lang=js"
export * from "./AboutUsHomePageSmallScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__